import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {EmailService} from '../../services/email.service';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
    templateUrl: 'email.component.html',
})
export class EmailComponent implements OnInit, OnDestroy {

    constructor(
        public es: EmailService,
        public authenticationService: AuthenticationService
    ) {}

    ngOnInit() {
        if(!this.authenticationService.userIsResident) {
            this.es.getBuildingsShort();
        }
        this.es.getGroups();
        this.es.urlService.onUrlChange.subscribe(() => {
            this.es.getAllMailings();
        });
        this.es.urlService.setQueryParams('email');
    }

    ngOnDestroy() {
        this.es.urlService.onUrlChange.observers = [];
        this.es.resetData();
        this.es.urlService.resetQueryParams();
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.es.emptyRowService.fillEmptyRow();
    }

}





// WEBPACK FOOTER //
// /app/src/app/views/email/email.component.ts